import { useTranslation } from '@/lib/i18n';
import { StatusPill } from '@/components/ui';
import { resolveArtistStatus } from '@/lib/domain';

export interface ArtistStatusPillProps {
  status: string | null | undefined;
  artistId?: string;
}

export const ArtistStatusPill = ({ status, artistId }: ArtistStatusPillProps) => {
  const { t } = useTranslation('artists');
  const meta = resolveArtistStatus(status, artistId ? { artistId } : undefined);
  return (
    <StatusPill
      variant={meta.badge}
      displayStatus={status}
      label={t(meta.i18nKey, status ?? '')}
      testId="artist-status-pill"
    />
  );
};
